module.exports = __webpack_public_path__ + "img/login-solar-hero.4e34a111.jpg";